// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".guide-home[data-v-78240dc4]{max-width:1752px;padding:32px 64px;margin:0 auto;display:flex;flex-direction:column;gap:55px}@media(max-width:500px){.guide-home[data-v-78240dc4]{padding:32px 24px}}", ""]);
// Exports
module.exports = exports;
